// APP
import DomainBox from "./DomainBox.js";
import { brand, brand_url,view_route, results_path } from "data/Spec";

import React, { useEffect, useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { NavLink, useParams } from "react-router-dom";

// tab
import { Form } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { LinkContainer } from "react-router-bootstrap";
import { format, isEqual, parse } from "date-fns";

function DomainSearchBox() {
  const intl = useIntl();
  const { listType } = useParams();
  const title = intl.formatMessage({ id: view_route[listType].title_id });
  useEffect(() => {
    document.title = title;
  });

  const today = new Date();
  const [state, setState] = useState(new Date());

  var url = "";

  if (isEqual(today, state)) {
    url = results_path + "/" + listType + ".json";
  } else {
    url =
      results_path +
      "/" +
      format(state, "yyyy") +
      "/" +
      listType +
      "." +
      format(state, "yyyyMMdd") +
      ".json";
  }

  var viewMenu = [];
  for (let key in view_route) {
    var path = "/view/" + key;
    viewMenu.push(
      <div key={key}>
        <LinkContainer to={path}>
          <NavDropdown.Item>
            <FormattedMessage id={view_route[key]["title_id"]} />
          </NavDropdown.Item>
        </LinkContainer>
      </div>
    );
  }

  return (
    <div>
      <header className="App-header">
        <h1>{title}</h1>
      </header>
      <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href={brand_url}>{brand}</Navbar.Brand>
          <Nav className="me-auto my-2 my-lg-0">
            <NavLink to="/" className="nav-link">TOP</NavLink>
            <NavLink to={url} className="nav-link">Download</NavLink>
            <Navbar.Collapse id="basic-navbar-nav">
              <NavDropdown title="Type" id="navbarScrollingDropdown">
                {viewMenu}
              </NavDropdown>
            </Navbar.Collapse>
          </Nav>
          <Form className="d-flex">
            <Form.Control
              type="date"
              placeholder="date of checks"
              onChange={(e) => {
                setState(parse(e.target.value, "yyyy-MM-dd", new Date()));
              }}
            />
          </Form>
        </Container>
      </Navbar>
      <DomainBox url={url} />
    </div>
  );
}

export default DomainSearchBox;
